import React from 'react';
import { T } from '@transifex/react';

import { useListPrincipals } from 'src/api/principals/hooks';
import {
  useActivePrincipalId,
  useSwitchPrincipal,
} from 'src/app/Principal.store';
import { Button } from '@/components/ui/button';

// Global "acting on behalf of X" bar (REQ-20), mounted above <InfoBanners/> in
// Content.tsx. Renders only when a principal is active; high-contrast brand bar
// with a one-click return to your own account.
export const ActingAsBanner: React.FC = () => {
  const activeId = useActivePrincipalId();
  const { data } = useListPrincipals();
  const switchPrincipal = useSwitchPrincipal();

  if (!activeId) return null;

  const principal = data?.principals.find((p) => p.id === activeId);

  return (
    <div className="wh-ui">
      <div
        role="status"
        aria-live="polite"
        className="flex flex-wrap items-center justify-between gap-2 bg-primary px-6 py-2.5 text-sm text-primary-foreground"
      >
        <span className="font-medium">
          <T
            _str="You are acting on behalf of {name}"
            name={principal?.displayName ?? '…'}
          />
        </span>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={() => switchPrincipal(null)}
        >
          <T _str="Return to your account" />
        </Button>
      </div>
    </div>
  );
};
